var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context-menu",style:({ top: `${_vm.menuTop}px`, left: `${_vm.menuLeft}px` }),on:{"mouseleave":_vm.hideMenu}},[_c('ul',{staticClass:"menu-items"},_vm._l((_vm.menuItems),function(item){return _c('li',{key:item.id,on:{"click":function($event){return _vm.handleItemClick(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }